import { TableRow, Tooltip } from '@mui/material';
import DataTableBodyCell from './DataTableBodyCell';
import { Can } from 'context';
import { useNavigate } from 'react-router-dom';
import { IconButton, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import MDButton from 'components/MDButton';
import { useMaterialUIController } from 'context';

const ACTION_BTN_SX = (color) => ({
  borderRadius: '8px',
  p: 0.75,
  transition: 'background 0.15s',
  '&:hover': {
    backgroundColor: color === 'error'
      ? 'rgba(229,115,115,0.12)'
      : 'rgba(90,163,255,0.12)'
  }
});

function DataTableBodyRow({
  row,
  noEndBorder,
  object,
  noActions,
  openDelete,
  handleCloseDelete,
  handleDelete,
  onView,
  rowsLength,
  showOnly,
  rowIndex
}) {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const isEven = rowIndex % 2 === 0;
  const zebraColor = darkMode
    ? isEven ? 'transparent' : 'rgba(255,255,255,0.025)'
    : isEven ? 'transparent' : 'rgba(0,0,0,0.018)';
  return (
    <TableRow
      {...row.getRowProps()}
      sx={{
        backgroundColor: zebraColor,
        transition: 'background-color 0.15s',
        '&:hover': {
          backgroundColor: darkMode ? 'rgba(90,163,255,0.07)' : 'rgba(26,115,232,0.05)'
        }
      }}
    >
      {row.cells.map((cell, index) => (
        <DataTableBodyCell
          key={`player-data-${index}`}
          noBorder={noEndBorder && rowsLength - 1 === key}
          align={cell.column.align ? cell.column.align : 'left'}
          {...cell.getCellProps()}
          expanded={row.isExpanded}
        >
          {cell.render('Cell')}
        </DataTableBodyCell>
      ))}
      {!noActions && (
        <DataTableBodyCell noBorder={noEndBorder && rowsLength - 1 === index} width='0.5rem' align='left'>
          <Can I='read' a={object}>
            <Tooltip title={onView ? 'View Dashboard' : 'View'}>
              <IconButton
                color='info'
                sx={ACTION_BTN_SX('info')}
                onClick={() =>
                  onView ? onView(row?.original) : navigate(`show/${row?.original?.id}`, { replace: false })
                }
              >
                <Icon sx={{ fontSize: '1.1rem !important' }}>visibility</Icon>
              </IconButton>
            </Tooltip>
          </Can>
          <Can I='update' a={object}>
            <Tooltip title='Edit'>
              <IconButton color='info' sx={ACTION_BTN_SX('info')} onClick={() => navigate(`edit/${row?.original?.id}`, { replace: false })}>
                <Icon sx={{ fontSize: '1.1rem !important' }}>edit</Icon>
              </IconButton>
            </Tooltip>
          </Can>
          <Can I='delete' a={object}>
            <Tooltip title='Delete'>
              <IconButton
                color='error'
                sx={ACTION_BTN_SX('error')}
                onClick={() => handleDelete(row?.original?.id)}
              >
                <Icon sx={{ fontSize: '1.1rem !important' }}>delete</Icon>
              </IconButton>
            </Tooltip>
            <Dialog
              open={openDelete}
              onClose={handleCloseDelete}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>{`Delete ${object}`}</DialogTitle>
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  Are you sure you want to delete this {object}?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <MDButton variant='text' onClick={handleCloseDelete}>
                  No
                </MDButton>
                <MDButton variant='text' color='error' onClick={() => handleDelete(row?.original?.id)}>
                  yes
                </MDButton>
              </DialogActions>
            </Dialog>
          </Can>
        </DataTableBodyCell>
      )}
      {showOnly && (
        <DataTableBodyCell noBorder={noEndBorder && rowsLength - 1 === rowIndex} width='0.5rem' align='left'>
          <Can I='read' a={object}>
            <Tooltip title={onView ? 'View Dashboard' : 'View'}>
              <IconButton
                color='info'
                sx={ACTION_BTN_SX('info')}
                onClick={() =>
                  onView ? onView(row?.original) : navigate(`show/${row?.original?.id}`, { replace: false })
                }
              >
                <Icon sx={{ fontSize: '1.1rem !important' }}>visibility</Icon>
              </IconButton>
            </Tooltip>
          </Can>
        </DataTableBodyCell>
      )}
    </TableRow>
  );
}

export default DataTableBodyRow;
